import { Benefit, MetaBenefits } from "@/types/component";
import BenefitAPEnhanceAutomated from "@/assets/illustrations/benefits-ap-enhance-automated.svg";
import BenefitAPFreeVendor from "@/assets/illustrations/benefits-ap-free-vendor.svg";
import BenefitAPImproveCash from "@/assets/illustrations/benefits-ap-improve-cash.svg";
import BenefitAPImprovePayment from "@/assets/illustrations/benefits-ap-improve-payment.svg";
import BenefitAPInvoiceApproval from "@/assets/illustrations/benefits-ap-invoice-approval.svg";
import BenefitAREliminateInvoice from "@/assets/illustrations/benefits-ar-eliminate-invoice.svg";
import BenefitAREnhanceCustomer from "@/assets/illustrations/benefits-ar-enhance-customer.svg";
import BenefitARGreatCustomer from "@/assets/illustrations/benefits-ar-great-customer.svg";
import BenefitARImproveRevenue from "@/assets/illustrations/benefits-ar-improve-revenue.svg";
import BenefitARReduceDSO from "@/assets/illustrations/benefits-ar-reduce-dso.svg";
import MaketingBenefit1 from "@/assets/illustrations/marketing-benefit-1.svg";
import MaketingBenefit2 from "@/assets/illustrations/marketing-benefit-2.svg";
import MaketingBenefit3 from "@/assets/illustrations/marketing-benefit-3.svg";
import MaketingBenefit4 from "@/assets/illustrations/marketing-benefit-4.svg";

const benefitsOfAR: Benefit[] = [
  {
    title: "Invoice and Email tracking",
    short_description:
      "Reduce your DSO cycle by tracking invoice email delivery status in real time and automating follow-up actions to accelerate customer payment cycles without any human involvement",
    illustration: BenefitARReduceDSO,
    illustrationClassName: "size-full",
  },
  {
    title: "Eliminate Invoice to Payment Reconciliation",
    short_description:
      "Let your team focus on proactive and strategic activities while zanbio automates the reconciliation process though our ePayment offerings",
    illustration: BenefitAREliminateInvoice,
    illustrationClassName: "size-full",
  },
  {
    title: "AI driven customer profiling and payment forecasting",
    short_description:
      "zanbio goes beyond traditional aging and due date forecasts, our AI model tracks customer payment patterns in real time to provide accurate profiling and payment forecasting",
    illustration: BenefitAREnhanceCustomer,
    illustrationClassName: "size-full",
  },
  {
    title: "Improve revenue leakage",
    short_description:
      "Streamline disputes and collect debt faster. Use smart workflow tools to speed up dispute resolution and keep customers satisfied",
    illustration: BenefitARImproveRevenue,
    illustrationClassName: "size-full",
  },
  {
    title:
      "Focus on more than just collections—enhance the customer experience. ",
    short_description:
      "Give your customers a self-service portal to easily manage invoices and payments, making their experience smoother and helping you get paid faster!",
    illustration: BenefitARGreatCustomer,
    illustrationClassName: "size-full",
  },
];

const benefitsOfAP: Benefit[] = [
  {
    title: "Touch free vendor invoice entry",
    short_description:
      "Our invoice AI service reads any invoice format, whether scanned or PDF, and automatically transfers the data onto the platform",
    illustration: BenefitAPFreeVendor,
    illustrationClassName: "size-full",
  },
  {
    title: "Built-in invoice approval workflow",
    short_description:
      "zanbio enables you to build in approval milestones that send alerts to approvers, allowing invoices and payments to review and approve in minutes",
    illustration: BenefitAPInvoiceApproval,
    illustrationClassName: "size-full",
  },
  {
    title: "Enhanced security and fraud detection",
    short_description:
      "zanbio helps protect your business from fraud by monitoring vendor invoice patterns and monitoring invoice behaviour for any abnormalities that could present a risk to your business",
    illustration: BenefitAPImprovePayment,
    illustrationClassName: "w-full h-fit",
  },
  {
    title: "Enhance Automated PO to Invoice Matching",
    short_description:
      "Eliminate the need to go through each vendor invoice manually and spend long periods of time performing invoice matching. Our automated matching system reads and matches invoices against PO's",
    illustration: BenefitAPEnhanceAutomated,
    illustrationClassName: "size-full",
  },
  {
    title: "Enhance cash outflow forecasting",
    short_description:
      "Comprehensive dashboards provide an unobscured view of your payment cycle, offering real-time data access and analytics",
    illustration: BenefitAPImproveCash,
    illustrationClassName: "size-full",
  },
];

export const metaBenefitsOfAP: MetaBenefits = {
  title: "Benefits",
  subtitle: "zanbio AP Automation",
  contents: benefitsOfAP,
};

export const metaBenefitsOfAR: MetaBenefits = {
  title: "Benefits",
  subtitle: "zanbio AR Automation",
  contents: benefitsOfAR,
};

export const marketingARBenefits: Benefit[] = [
  {
    title: "Invoice and Email tracking",
    short_description:
      "Reduce your DSO cycle by tracking invoice email delivery status in real time and automating follow-up actions to accelerate customer payment cycles without any human involvement",
    illustration: MaketingBenefit1,
    illustrationClassName: "size-full",
  },
  {
    title: "Eliminate Invoice to Payment Reconciliation",
    short_description:
      "Let your team focus on proactive and strategic activities while zanbio automates the reconciliation process though our ePayment offerings",
    illustration: MaketingBenefit2,
    illustrationClassName: "size-full",
  },
  {
    title: "AI driven customer profiling & payment forecasting",
    short_description:
      "zanbio goes beyond traditional aging and due date forecasts, our AI model tracks customer payment patterns in real time to provide accurate profiling and payment forecasting",
    illustration: MaketingBenefit3,
    illustrationClassName: "size-full",
  },
  {
    title: "Improve revenue leakage",
    short_description:
      "Streamline disputes and collect debt faster. Use smart workflow tools to speed up dispute resolution and keep customers satisfied",
    illustration: MaketingBenefit4,
    illustrationClassName: "size-full",
  },
];
